import React from 'react';
import { GradingSplitPane } from 'components/result/GradingSplitPane';
import { useIsMobile } from 'hooks/use-media-query';
import { GradingMobile } from 'components/mobile/screens/GradingMobile';

/** Cross-test grading queue. On phones the split-pane gives way to the mobile queue + full-screen grader. */
const ManualGrading: React.FC = () => (useIsMobile() ? <GradingMobile /> : <GradingSplitPane />);

export default ManualGrading;
